import InputFactory from '@/components/InputFactory';
import { isObject, isStringAndNotEmpty } from '@/utils/langUtils';
import { isNumber } from 'lodash';
import Vue from 'vue';

export default function (Survey, vm, props) {

  const component = {};
  component.name = props.name;
  component.title = props.title;
  component.iconName = props.iconName;
  component.widgetIsLoaded = function () {
    return true;
  };
  component.isFit = function (question) {
    const type = props && props.type ? props.type : null;
    return question.getType() === type;
  };
  component.init = function () {
    Survey.Serializer.addClass(props.name, [], null, 'empty');
  };
  component.isDefaultRender =
    props.isDefaultRender !== undefined ? props.isDefaultRender : true;
  component.htmlTemplate =
    props.htmlTemplate !== undefined
      ? props.htmlTemplate
      : '<div>Loading field...</div>';
  component.afterRender = function (question, el) {

    if (props.type == "list-collaborator") {
      if (vm.survey) {
        var getIDs;
        getIDs = new Array;
        if (props.type == "list-collaborator") {
          if (question.parentQuestion && vm.survey.data[question.parentQuestion.code] !== undefined) {
            for (let row of vm.survey.data[question.parentQuestion.code]) {
              if (row[question.name] !== undefined) {
                getIDs.push(row[question.name][0]['ID'])
              }
            }
          }
        }




        const { propsData } = props;

        while (el && el.lastChild) el.removeChild(el.lastChild);


        const ComponentClass = Vue.extend(InputFactory);
        const instance = new ComponentClass({

          propsData: {
            ...propsData,
            value: question.value,
            matrixValues: getIDs,
            surveydata: vm.survey.data,
            parentQuestionCode: question.parentQuestion ? question.parentQuestion.code : null,
            questionName: question.name

          },
          parent: vm,
        });
        instance.$mount();
        instance.$on('input', data => {
          if (props.type == "list-collaborator" && Array.isArray(data)) {
            try {
              let matrix = question.parentQuestion;
              if (matrix) {
                matrix.clearValue();
                let count = 0;
                while (count <= matrix.rowCounter) {
                  matrix.removeRow(0);
                  count++
                }

                question.value = 'temp';

                data.forEach((element, index) => {

                  matrix.addRow();

                  matrix.setRowValue(index, { "Column 1": [element] });

                });
              }
            } catch (error) {
              console.log(error)
            }

          } else {
            question.value = data;

            instance.$props.value = data;

            vm.$emit('updateCustomMatrixValues', vm.survey.data);
          }
          instance.$children[0]['showDialog'] = false;

        });
        $(el).attr('id', question.id);
        el.append(instance.$el);
      }
      else {
        el.append("TEST MODE");
      }
    } else {
      const { propsData } = props;

      while (el && el.lastChild) el.removeChild(el.lastChild);


      const ComponentClass = Vue.extend(InputFactory);
      const instance = new ComponentClass({

        propsData: {
          ...propsData,
          value: question.value,
          matrixValues: null,
          surveydata: null,
          parentQuestionCode: question.parentQuestion ? question.parentQuestion.code : null,
          questionName: question.name

        },
        parent: vm,
      });
      instance.$mount();
      instance.$on('input', data => {

        question.value = data;

        instance.$props.value = data;

        //instance.$children[0]['showDialog']=false;

      });
      $(el).attr('id', question.id);
      el.append(instance.$el);
    }






  };
  component.willUnmount = function (question, el) {
    while (el && el.lastChild) el.removeChild(el.lastChild);
  };
  component.pdfQuestionType = "empty",
    component.pdfRender = function (survey, options) {
      if (options.question.getType() !== type)
        return;
      const answer = options.question.value;
      const localizableStr = new Survey.LocalizableString(survey, true);
      let answerText = "";
      if (isStringAndNotEmpty(answer) || isNumber(answer)) {
        answerText = answer;
      } else if (Array.isArray(answer)) {
        for (answer of ans) {
          const ans = answer[i];
          if (isStringAndNotEmpty(answer) || isNumber(answer)) {
            answerText += `${ans}${i < answer.length - 1 ? ',' : ''}`;
          } else if (isObject(ans, true) && isObject(ans.text, true)) {
            // is list view
            answerText += "<p>";
            for (const col in ans.text) {
              answerText += `<span>${ans.text[col]}</span>`;
            }
            answerText += "</p>";
          }
        }
      }
      localizableStr.text = answerText;
      options.question['locHtml'] = localizableStr;
      if (options.question.renderAs === "standard" || options.question.renderAs === "image") {
        options.question["renderAs"] = options.question.renderAs;
      } else {
        options.question["renderAs"] = "auto";
      }
      const flatHtml = options.repository.create(survey, options.question, options.controller, "html");
      return new Promise(function (resolve) {
        flatHtml.generateFlats(options.point).then(function (htmlBricks) {
          options.bricks = htmlBricks;
          resolve();
        });
      });
    }
  if (!Survey.CustomWidgetCollection.Instance.getCustomWidgetByName(props.name)) {
    Survey.CustomWidgetCollection.Instance.addCustomWidget(component, "customtype");
  }
}
